module.exports = __webpack_public_path__ + "img/receipt-cutoff.896131cd.svg";